import React from 'react';
import Footer from '../components/Footer';
import MainSection from '../components/MainSection';
import Navbar from '../components/Navbar';

const HomePage = () => {
  return (
    <div>
      <Navbar />
      <MainSection />
      <Footer />
    </div>
  );
};

export default HomePage;
